<template>
    <div>
        <b-modal :id="modalId"
            modal-class="modal-success"
            hide-header
            hide-footer
            no-close-on-backdrop
            no-close-on-esc>
            <div class="modal-base">
                <div class="modal-base-head">
                    <div class="icon-check">
                        <img class="img-fluid" src="@/assets/icon/icon_success.svg">
                    </div>
                </div>
                <div class="modal-base-body">
                    <div class="text-title">{{message}}</div>
                </div>
                <div class="modal-base-footer">
                    <div class="btn-confirm" @click="clickOk()">
                        <div class="btn-txt">
                            {{btnOk}}
                        </div>
                    </div>
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
//helper
import Locale from '@/helper/locale/locale.js';
import Util from '@/helper/Utility.js';

export default {
    name: 'SuccessModal',
    props: {
        controller: Object,
        modalId: String
    },
    data: function () {
        return {
            title: '',
            message: '',
            btnOk: '',
            tag: '',
            busModal: null,
            lbl: Locale.getLbl(),
        };
    },
    created: function () {
        this.busModal = this.controller.busModal;
    },
    mounted: function () {
        this.busModal.$on('show', this.show);
        this.busModal.$on('hide', this.hide);
    },
    methods: {
        clickOk: function(){
            this.hide();
            this.controller.sendCallbackOk({ tag: this.tag });
        },
        close: function () {
            this.hide();
        },
        show: function (config) {
            this.title = config.title;
            this.message = config.msg;
            this.btnOk = config.btnOk;
            this.tag = config.tag;
            if (Util.isEmptyStr(config.btnOk)) {
                this.btnOk = this.lbl.default.ok;
            }
            this.$bvModal.show(this.modalId);
        },
        hide: function () {
            this.$bvModal.hide(this.modalId);
        }
    }
}
</script>
<style lang="scss" scoped>
@import '@/style/base/base.scss';
@import '@/style/input/BaseButton.scss';
.modal-success {
    .modal-body{
        .modal-base-head{
            .icon-check{
                padding: 40px 0 20px;
                img{
                    width: 62px;
                }
            }
        }

        .modal-base-body{
            font-family: $medium;
            font-size: 1.25rem;

            @include mini-mobile(){
                font-size: 1.1rem;
            }

            .text-title{
                color: $green; 
                padding: 15px 0 60px;
            }
        }

        .btn-confirm{
            @include btn-wrapper();
            width: 100%;
            margin: 0 auto 30px;
        }
    }
}
</style>
<style lang="scss">
.modal-success{
    .modal-body{
        width: 100%;
        padding: 0 20px; 
        margin: auto;
        text-align: center;
    }
    .modal-dialog {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        width: 100%;
        margin: auto;
    }

    .modal-content{
        border: none;
        border-top-left-radius: 30px;
        border-top-right-radius: 30px;
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
    }

}
</style>
